import type { FunctionComponent } from 'react'
import { createGlobalStyle } from 'styled-components'

export const DotAnimationKeyframes = createGlobalStyle`  @keyframes dot1 {
    0%,15% { 
      opacity: 0;
          }
    25%,95% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes dot2 {
    0%, 40% { 
      opacity: 0;
         }
    50%,95% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes dot3 {
    0%,65%{ 
      opacity: 0;
            }
    75%,95% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  `
export const DotAnimationLoader: FunctionComponent<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <>
      <DotAnimationKeyframes />
      <span className="flex text-white font-semibold items-end justify-center">
        {children}
        <span className="animate-loader1 w-px-4 h-px-4 rounded-full bg-white ml-1 mb-[8px] ml:mb-[10px]" />
        <span className="animate-loader2 w-px-4 h-px-4 rounded-full bg-white ml-1 mb-[8px] ml:mb-[10px]" />
        <span className="animate-loader3 w-px-4 h-px-4 rounded-full bg-white ml-1 mb-[8px] ml:mb-[10px]" />
      </span>
    </>
  )
}
